import { cn } from './cnNew'

export function Card({ className, children, as: Tag = 'section', style, ...props }) {
  return (
    <Tag
      className={cn('rounded-xl bg-card', className)}
      style={{ border: '1px solid var(--border)', boxShadow: '0 1px 2px rgba(16,42,48,0.04)', ...style }}
      {...props}
    >
      {children}
    </Tag>
  )
}

export function CardHeader({ title, subtitle, actions, icon, className }) {
  return (
    <div className={cn('flex items-start justify-between gap-3 px-4 py-3.5', className)}>
      <div className="flex min-w-0 items-start gap-2.5">
        {icon}
        <div className="min-w-0">
          <h3 className="truncate text-[15px] font-semibold text-foreground">{title}</h3>
          {subtitle && (
            <p className="mt-0.5 truncate text-[12.5px] text-muted-foreground">{subtitle}</p>
          )}
        </div>
      </div>
      {actions && <div className="flex shrink-0 items-center gap-1">{actions}</div>}
    </div>
  )
}

export function EmptyState({ icon, title, description, action, className }) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-input bg-muted/40 px-6 py-10 text-center',
        className
      )}
    >
      {icon && <div className="text-muted-foreground">{icon}</div>}
      <div>
        <p className="text-sm font-semibold text-foreground">{title}</p>
        {description && (
          <p className="mx-auto mt-1 max-w-sm text-[13px] leading-relaxed text-muted-foreground">
            {description}
          </p>
        )}
      </div>
      {action}
    </div>
  )
}
